import AppError from '../errors/apperror';
import ERRORS from '../errors/errorids';
import Logger from '../logger/logger';
const log = Logger.get('storage');

let userKey; //not user id, instead md5 hash

function getUserStorage() {
	const userStorage = window.localStorage.getItem(userKey);
	try {
		return JSON.parse(userStorage) || {};
	} catch (err) {
		log.send(new AppError({
			message: 'Storage.getUserStorage() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}

	return {};
}

export function setItem(key, value, json) {
	value = json ? JSON.stringify(value) : value;

	const userStorage = getUserStorage();

	userStorage[key] = value;

	try {
		window.localStorage.setItem(userKey, JSON.stringify(userStorage));
	} catch (err) {

		log.send(new AppError({
			message: 'Storage.setItem() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'STORAGE' }
		}));
	}
}

export function getItem(key, json) {
	const item = getUserStorage()[key];

	if (json) {
		try {
			return JSON.parse(item);
		} catch (err) {
			log.send(new AppError({
				message: 'Storage.getItem() failed',
				errorId: ERRORS.UNKNOWN,
				originalError: err,
				visualisers: { feature: 'STORAGE' }
			}));
		}
	}

	return item;
}

export function setKey(key) {
	userKey = key;
}


// WEBPACK FOOTER //
// ./src/storage/index.js